import { gql } from "@apollo/client";
import { ApiService } from "./ApiService";
import { OpResult } from "@sdflc/api-helpers";

// GraphQL query
const ACCOUNT_FORM_SUBMISSION_STAT_GET_QUERY = gql`
  query AccountFormSubmissionStatGet {
    accountFormSubmissionStatGet {
      code
      data {
        formsCnt
        filesSize
        createdAt
        updatedAt
      }
      errors {
        name
        errors
        warnings
      }
    }
  }
`;

export interface AccountFormSubmissionStat {
  formsCnt?: number;
  filesSize?: string;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Account Form Submission Statistics service
 * Provides statistics about form submissions for the current account
 */
export class AccountFormSubmissionStatsService {
  /**
   * Get form submission statistics for the current account
   */
  static async get(): Promise<OpResult> {
    const result = await ApiService.executeQuery(
      ACCOUNT_FORM_SUBMISSION_STAT_GET_QUERY,
      {}
    );
    return result;
  }
}
